module.exports = __webpack_public_path__ + "img/img-3.18a79a02.png";